import axios from "axios";
import firebase from "./firebase";

const getAuthHeaders = async () => {
  const user = firebase.currentUser();
  const token = user && (await user.getIdToken());
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getSecureFileRetentionSettings = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/admin/secure-files/retention-settings`, {
      headers: await getAuthHeaders(),
    });
    return { data: response.data?.data };
  } catch (error) {
    return {
      error: {
        message: error.response?.data?.message || error.message,
        code: error.response?.data?.code,
      },
    };
  }
};

export const updateSecureFileRetentionSettings = async ({ patientFileRetentionDays, globalFileRetentionDays }) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}/admin/secure-files/retention-settings`,
      {
        patientFileRetentionDays,
        globalFileRetentionDays,
      },
      { headers: await getAuthHeaders() }
    );
    return { data: response.data?.data };
  } catch (error) {
    return {
      error: {
        message: error.response?.data?.message || error.message,
        code: error.response?.data?.code,
      },
    };
  }
};

export const RETENTION_YEAR_PRESETS = [
  { label: "1 year", value: 365 },
  { label: "3 years", value: 3 * 365 },
  { label: "5 years", value: 5 * 365 },
  { label: "7 years (default)", value: 7 * 365 },
  { label: "10 years", value: 10 * 365 },
];

export const daysToYearsLabel = (days) => {
  if (!days) {
    return "—";
  }
  const years = days / 365;
  if (Number.isInteger(years)) {
    return `${years} year${years === 1 ? "" : "s"}`;
  }
  return `${days} days`;
};
